import { X } from "lucide-react";
import { useState } from "react";

export const AdsPromoBanner = () => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className="bg-foreground text-background text-center text-sm py-2 px-4 relative z-50">
      <span className="font-semibold">🔥 Limited Time Offer:</span>{" "}
      <span>Get <strong>$500 OFF</strong> your next roof replacement — Call today!</span>
      <button
        onClick={() => setVisible(false)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-background/70 hover:text-background"
        aria-label="Close banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
